import { render, staticRenderFns } from "./addAndEdit.vue?vue&type=template&id=63430a7a&scoped=true"
import script from "./addAndEdit.vue?vue&type=script&lang=js"
export * from "./addAndEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63430a7a",
  null
  
)

export default component.exports